// extracted by mini-css-extract-plugin
export default {"target":"su4IH5RuKZmipabxZ_1G"};